// 物资管理
import Log from "../view/log";
import MaterialManagementNav from "../view/MaterialManagement/MaterialManagementNav";
import MaterialManage from "../view/MaterialManagement/MaterialManage/MaterialManage";
import MaterialManageAdd from "../view/MaterialManagement/MaterialManage/MaterialManageAdd";
import MaterialManageModify from "../view/MaterialManagement/MaterialManage/MaterialManageModify";
import MaterialCategoryManage from "../view/MaterialManagement/MaterialCategory/MaterialCategoryManage";
import MaterialCategoryAdd from "../view/MaterialManagement/MaterialCategory/MaterialCategoryAdd";
import MaterialCategoryModify from "../view/MaterialManagement/MaterialCategory/MaterialCategoryModify";
import WarehousingManagement from "../view/MaterialManagement/WarehousingManagement/WarehousingManagement";
import WarehousingManagementAdd from "../view/MaterialManagement/WarehousingManagement/WarehousingManagementAdd";
import WarehousingManagementModify from "../view/MaterialManagement/WarehousingManagement/WarehousingManagementModify";
import MaterialRequisition from "../view/MaterialManagement/MaterialRequisition/MaterialRequisition";
import MaterialRequisitionAdd from "../view/MaterialManagement/MaterialRequisition/MaterialRequisitionAdd";
import MaterialRequisitionModify from "../view/MaterialManagement/MaterialRequisition/MaterialRequisitionModify";
import InventoryStatistics from "../view/MaterialManagement/InventoryStatistics/InventoryStatistics";
import MaterialInventory from "../view/MaterialManagement/MaterialInventory/MaterialInventory";
import MaterialInventoryAdd from "../view/MaterialManagement/MaterialInventory/MaterialInventoryAdd";
import MaterialInventoryModify from "../view/MaterialManagement/MaterialInventory/MaterialInventoryModify";
import InventoryList from "../view/MaterialManagement/MaterialInventory/InventoryList";
import InventoryReport from "../view/MaterialManagement/MaterialInventory/InventoryReport";
import ConsumingInventory from "../view/MaterialManagement/ConsumingInventory/ConsumingInventory";
import ConsumingInventoryAdd from "../view/MaterialManagement/ConsumingInventory/ConsumingInventoryAdd";
import ConsumingInventoryModify from "../view/MaterialManagement/ConsumingInventory/ConsumingInventoryModify";
import StockInventoryList from "../view/MaterialManagement/ConsumingInventory/StockInventoryList";
import StockInventoryReport from "../view/MaterialManagement/ConsumingInventory/StockInventoryReport";
import ConfigurationManagement from "../view/MaterialManagement/ConfigurationManagement/ConfigurationManagement";
import ConfigurationManagementAdd from "../view/MaterialManagement/ConfigurationManagement/ConfigurationManagementAdd";
import ConfigurationManagementModify from "../view/MaterialManagement/ConfigurationManagement/ConfigurationManagementModify";
import CollectingInventoryReport from "../view/MaterialManagement/CollectingInventoryReport/CollectingInventoryReport";
import CountInventoryReport from "../view/MaterialManagement/CountInventoryReport/CountInventoryReport";

export default [
  {
    path: "/material_category_manage",
    name: "material-category-manage",
    components: {
      default: MaterialManagementNav,
      a: MaterialCategoryManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/material_category_add",
    name: "material-category-add",
    components: {
      default: MaterialManagementNav,
      a: MaterialCategoryAdd
    }
  },
  {
    path: "/material_category_modify/:id",
    name: "material-category-modify",
    components: {
      default: MaterialManagementNav,
      a: MaterialCategoryModify
    }
  },
  {
    path: "/warehousing_management",
    name: "warehousing-management",
    components: {
      default: MaterialManagementNav,
      a: WarehousingManagement
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/warehousing_management_add",
    name: "warehousing-management-add",
    components: {
      default: MaterialManagementNav,
      a: WarehousingManagementAdd
    }
  },
  {
    path: "/warehousing_management_modify/:id",
    name: "warehousing-management-modify",
    components: {
      default: MaterialManagementNav,
      a: WarehousingManagementModify
    }
  },
  {
    path: "/material_requisition",
    name: "material-requisition",
    components: {
      default: MaterialManagementNav,
      a: MaterialRequisition
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/material_requisition_add",
    name: "material-requisition-add",
    components: {
      default: MaterialManagementNav,
      a: MaterialRequisitionAdd
    }
  },
  {
    path: "/material_requisition_modify/:id",
    name: "material-requisition-modify",
    components: {
      default: MaterialManagementNav,
      a: MaterialRequisitionModify
    }
  },
  {
    path: "/inventory_statistics",
    name: "inventory-statistics",
    components: {
      default: MaterialManagementNav,
      a: InventoryStatistics
    },

    meta: {
      keepAlive: true
    }
  },
  {
    path: "/material_inventory",
    name: "material-inventory",
    components: {
      default: MaterialManagementNav,
      a: MaterialInventory
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/material_inventory_add",
    name: "material-inventory-add",
    components: {
      default: MaterialManagementNav,
      a: MaterialInventoryAdd
    }
  },
  {
    path: "/material_inventory_modify/:id",
    name: "material-inventory-modify",
    components: {
      default: MaterialManagementNav,
      a: MaterialInventoryModify
    }
  },
  {
    path: "/inventory_list/:id",
    name: "inventory-list",
    components: {
      default: MaterialManagementNav,
      a: InventoryList
    }
  },
  {
    path: "/inventory_report/:id",
    name: "inventory-report",
    components: {
      default: MaterialManagementNav,
      a: InventoryReport
    }
  },
  {
    path: "/consuming_inventory",
    name: "consuming-inventory",
    components: {
      default: MaterialManagementNav,
      a: ConsumingInventory
    }
  },
  {
    path: "/consuming_inventory_add",
    name: "consuming-inventory-add",
    components: {
      default: MaterialManagementNav,
      a: ConsumingInventoryAdd
    }
  },
  {
    path: "/consuming_inventory_modify/:id",
    name: "consuming-inventory-modify",
    components: {
      default: MaterialManagementNav,
      a: ConsumingInventoryModify
    }
  },
  {
    path: "/stock_inventory_list/:id",
    name: "stock-inventory-list",
    components: {
      default: MaterialManagementNav,
      a: StockInventoryList
    }
  },
  {
    path: "/stock_inventory_report/:id",
    name: "stock-inventory-report",
    components: {
      default: MaterialManagementNav,
      a: StockInventoryReport
    }
  },
  {
    path: "/configuration_management",
    name: "configuration-management",
    components: {
      default: MaterialManagementNav,
      a: ConfigurationManagement
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/configuration_management_add",
    name: "configuration-management-add",
    components: {
      default: MaterialManagementNav,
      a: ConfigurationManagementAdd
    }
  },
  {
    path: "/configuration_management_modify/:id",
    name: "configuration-management-modify",
    components: {
      default: MaterialManagementNav,
      a: ConfigurationManagementModify
    }
  },
  {
    path: "/material_manage",
    name: "material-manage",
    components: {
      default: MaterialManagementNav,
      a: MaterialManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/material_manage_add",
    name: "material-manage-add",
    components: {
      default: MaterialManagementNav,
      a: MaterialManageAdd
    }
  },
  {
    path: "/material_manage_modify/:id",
    name: "material-manage-modify",
    components: {
      default: MaterialManagementNav,
      a: MaterialManageModify
    }
  },
  {
    path: "/collecting_inventory_report",
    name: "collecting-inventory-report",
    components: {
      default: MaterialManagementNav,
      a: CollectingInventoryReport
    }
  },
  {
    path: "/count_inventory_report",
    name: "count-inventory-report",
    components: {
      default: MaterialManagementNav,
      a: CountInventoryReport
    }
  },
  {
    path: "/material_log",
    name: "material-log",
    components: {
      default: MaterialManagementNav,
      a: Log
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/Material.js